import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

import { FadeInAnimation } from '../shared/fade-in.animation';

@Component({
  selector: 'app-save-as-dialog',
  templateUrl: './save-as-dialog.component.html',
  styleUrls: ['./save-as-dialog.component.scss'],
  animations: [FadeInAnimation]
})
export class SaveAsDialogComponent implements OnInit {

  copy: boolean;
  name: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.copy = (this.data.copy === true);
    if (this.copy) {
      let templateName = this.data.templateName;
      this.name = this.generateCopyName(templateName);
    } else {
      this.name = "untitled";
    }
  }

  generateCopyName(templateName): string {
    let match = templateName.match(/\bcopy(\s(\d+))?$/i)
    if (match != null) {
      if (match[2] != null) {
        let number = +match[2];
        return templateName.replace(match[0], "copy " + (number+1));
      } else {
        return templateName.replace(match[0], "copy 2");
      }
    } else {
      return templateName + " copy"
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/transfers/save-as-dialog.component.ts